// Theme extras: multiple background image queries (for rotation every 5 min)
// and bonus reward video (local MP4 clip played when the kid finishes early).

export type ThemeExtras = {
    /** Multiple Wikipedia article titles to fetch rotating background images. */
    bgQueries: string[];
    /** Local video file paths for the bonus reward (relative to public/). One is picked at random. */
    bonusVideoSrcs: string[];
};

export const THEME_EXTRAS: Record<string, ThemeExtras> = {
    'anime-dragonball-z': {
        bgQueries: ['Super Saiyan Blue Goku', 'Goku', 'Vegeta', 'Dragon Ball Super'],
        bonusVideoSrcs: [
            '/videos/anime-dragonball-z-01.mp4','/videos/anime-dragonball-z-02.mp4','/videos/anime-dragonball-z-03.mp4',
            '/videos/anime-dragonball-z-04.mp4','/videos/anime-dragonball-z-05.mp4','/videos/anime-dragonball-z-06.mp4',
            '/videos/anime-dragonball-z-07.mp4','/videos/anime-dragonball-z-08.mp4','/videos/anime-dragonball-z-09.mp4',
            '/videos/anime-dragonball-z-10.mp4','/videos/anime-dragonball-z-11.mp4','/videos/anime-dragonball-z-12.mp4',
            '/videos/anime-dragonball-z-13.mp4','/videos/anime-dragonball-z-14.mp4','/videos/anime-dragonball-z-15.mp4',
            '/videos/anime-dragonball-z-16.mp4','/videos/anime-dragonball-z-17.mp4','/videos/anime-dragonball-z-18.mp4',
            '/videos/anime-dragonball-z-19.mp4','/videos/anime-dragonball-z-20.mp4','/videos/anime-dragonball-z-21.mp4',
        ],
    },
    'anime-buu': {
        bgQueries: ['Majin Buu', 'Goku Super Saiyan 3', 'Dragon Ball Z'],
        bonusVideoSrcs: [
            '/videos/anime-buu-01.mp4','/videos/anime-buu-02.mp4','/videos/anime-buu-03.mp4',
            '/videos/anime-buu-04.mp4','/videos/anime-buu-05.mp4','/videos/anime-buu-06.mp4',
            '/videos/anime-buu-07.mp4','/videos/anime-buu-08.mp4','/videos/anime-buu-10.mp4',
            '/videos/anime-buu-11.mp4','/videos/anime-buu-12.mp4','/videos/anime-buu-13.mp4',
        ],
    },
    'anime-conan': {
        bgQueries: ['Case Closed', 'Detective Conan', 'Shinichi Kudo'],
        bonusVideoSrcs: [
            '/videos/anime-conan-01.mp4','/videos/anime-conan-02.mp4','/videos/anime-conan-04.mp4',
            '/videos/anime-conan-05.mp4','/videos/anime-conan-06.mp4','/videos/anime-conan-07.mp4',
            '/videos/anime-conan-08.mp4','/videos/anime-conan-09.mp4','/videos/anime-conan-10.mp4',
            '/videos/anime-conan-11.mp4','/videos/anime-conan-12.mp4','/videos/anime-conan-13.mp4',
        ],
    },
    'anime-beyblade-x': {
        bgQueries: ['Beyblade', 'Beyblade X', 'Beyblade anime'],
        bonusVideoSrcs: [
            '/videos/anime-beyblade-x-03.mp4','/videos/anime-beyblade-x-05.mp4','/videos/anime-beyblade-x-06.mp4',
            '/videos/anime-beyblade-x-08.mp4','/videos/anime-beyblade-x-15.mp4','/videos/anime-beyblade-x-17.mp4',
            '/videos/anime-beyblade-x-18.mp4','/videos/anime-beyblade-x-19.mp4','/videos/anime-beyblade-x-20.mp4',
            '/videos/anime-beyblade-x-21.mp4','/videos/anime-beyblade-x-22.mp4','/videos/anime-beyblade-x-23.mp4',
        ],
    },
    'anime-tsubasa': {
        bgQueries: ['Captain Tsubasa', 'Tsubasa Ozora', 'Captain Tsubasa anime'],
        bonusVideoSrcs: [
            '/videos/anime-tsubasa-01.mp4','/videos/anime-tsubasa-03.mp4','/videos/anime-tsubasa-04.mp4',
            '/videos/anime-tsubasa-05.mp4','/videos/anime-tsubasa-06.mp4','/videos/anime-tsubasa-07.mp4',
            '/videos/anime-tsubasa-09.mp4','/videos/anime-tsubasa-10.mp4','/videos/anime-tsubasa-11.mp4',
            '/videos/anime-tsubasa-12.mp4','/videos/anime-tsubasa-13.mp4','/videos/anime-tsubasa-14.mp4',
        ],
    },
    'anime-kuroko': {
        bgQueries: ["Kuroko's Basketball", 'Kuroko Tetsuya', 'Generation of Miracles'],
        bonusVideoSrcs: [
            '/videos/anime-kuroko-01.mp4','/videos/anime-kuroko-02.mp4','/videos/anime-kuroko-03.mp4',
            '/videos/anime-kuroko-04.mp4','/videos/anime-kuroko-05.mp4','/videos/anime-kuroko-06.mp4',
            '/videos/anime-kuroko-07.mp4','/videos/anime-kuroko-08.mp4','/videos/anime-kuroko-09.mp4',
            '/videos/anime-kuroko-10.mp4','/videos/anime-kuroko-11.mp4','/videos/anime-kuroko-12.mp4',
        ],
    },
    'anime-slam-dunk': {
        bgQueries: ['Slam Dunk (manga)', 'Hanamichi Sakuragi', 'Slam Dunk anime'],
        bonusVideoSrcs: [
            '/videos/anime-slam-dunk-02.mp4','/videos/anime-slam-dunk-03.mp4','/videos/anime-slam-dunk-04.mp4',
            '/videos/anime-slam-dunk-05.mp4','/videos/anime-slam-dunk-06.mp4','/videos/anime-slam-dunk-07.mp4',
            '/videos/anime-slam-dunk-08.mp4','/videos/anime-slam-dunk-09.mp4','/videos/anime-slam-dunk-10.mp4',
            '/videos/anime-slam-dunk-12.mp4','/videos/anime-slam-dunk-13.mp4','/videos/anime-slam-dunk-14.mp4',
        ],
    },
    'anime-pokemon': {
        bgQueries: ['Pikachu', 'Pokemon anime', 'Ash Ketchum'],
        bonusVideoSrcs: [
            '/videos/anime-pokemon-01.mp4','/videos/anime-pokemon-13.mp4','/videos/anime-pokemon-14.mp4',
            '/videos/anime-pokemon-16.mp4','/videos/anime-pokemon-18.mp4','/videos/anime-pokemon-20.mp4',
            '/videos/anime-pokemon-23.mp4','/videos/anime-pokemon-24.mp4','/videos/anime-pokemon-31.mp4',
            '/videos/anime-pokemon-34.mp4','/videos/anime-pokemon-35.mp4','/videos/anime-pokemon-37.mp4',
        ],
    },
    'anime-naruto': {
        bgQueries: ['Naruto', 'Naruto Uzumaki', 'Sasuke Uchiha'],
        bonusVideoSrcs: [
            '/videos/anime-naruto-01.mp4','/videos/anime-naruto-02.mp4','/videos/anime-naruto-03.mp4',
            '/videos/anime-naruto-04.mp4','/videos/anime-naruto-05.mp4','/videos/anime-naruto-06.mp4',
            '/videos/anime-naruto-08.mp4','/videos/anime-naruto-09.mp4','/videos/anime-naruto-10.mp4',
            '/videos/anime-naruto-11.mp4','/videos/anime-naruto-12.mp4','/videos/anime-naruto-13.mp4',
            '/videos/anime-naruto-14.mp4','/videos/anime-naruto-15.mp4','/videos/anime-naruto-16.mp4',
        ],
    },
    'anime-onepiece': {
        bgQueries: ['Monkey D. Luffy', 'One Piece', 'Straw Hat Pirates'],
        bonusVideoSrcs: [
            '/videos/anime-onepiece-01.mp4','/videos/anime-onepiece-02.mp4','/videos/anime-onepiece-03.mp4',
            '/videos/anime-onepiece-04.mp4','/videos/anime-onepiece-05.mp4','/videos/anime-onepiece-06.mp4',
            '/videos/anime-onepiece-07.mp4','/videos/anime-onepiece-08.mp4','/videos/anime-onepiece-09.mp4',
            '/videos/anime-onepiece-10.mp4','/videos/anime-onepiece-11.mp4','/videos/anime-onepiece-12.mp4',
            '/videos/anime-onepiece-13.mp4','/videos/anime-onepiece-14.mp4','/videos/anime-onepiece-15.mp4',
        ],
    },
    'anime-demonslayer': {
        bgQueries: ['Tanjiro Kamado', 'Demon Slayer', 'Nezuko Kamado'],
        bonusVideoSrcs: [
            '/videos/anime-demonslayer-02.mp4','/videos/anime-demonslayer-04.mp4','/videos/anime-demonslayer-05.mp4',
            '/videos/anime-demonslayer-06.mp4','/videos/anime-demonslayer-07.mp4','/videos/anime-demonslayer-08.mp4',
            '/videos/anime-demonslayer-10.mp4','/videos/anime-demonslayer-11.mp4','/videos/anime-demonslayer-12.mp4',
            '/videos/anime-demonslayer-13.mp4','/videos/anime-demonslayer-14.mp4','/videos/anime-demonslayer-15.mp4',
        ],
    },
    'anime-mha': {
        bgQueries: ['My Hero Academia', 'Izuku Midoriya', 'All Might'],
        bonusVideoSrcs: [
            '/videos/anime-mha-01.mp4','/videos/anime-mha-03.mp4','/videos/anime-mha-04.mp4',
            '/videos/anime-mha-05.mp4','/videos/anime-mha-06.mp4','/videos/anime-mha-07.mp4',
            '/videos/anime-mha-08.mp4','/videos/anime-mha-10.mp4','/videos/anime-mha-11.mp4',
            '/videos/anime-mha-12.mp4','/videos/anime-mha-13.mp4','/videos/anime-mha-14.mp4',
        ],
    },
    'anime-doraemon': {
        bgQueries: ['Doraemon', 'Doraemon characters', 'Nobita Nobi'],
        bonusVideoSrcs: [
            '/videos/anime-doraemon-02.mp4','/videos/anime-doraemon-05.mp4','/videos/anime-doraemon-07.mp4',
            '/videos/anime-doraemon-08.mp4','/videos/anime-doraemon-10.mp4','/videos/anime-doraemon-11.mp4',
            '/videos/anime-doraemon-12.mp4','/videos/anime-doraemon-20.mp4','/videos/anime-doraemon-22.mp4',
            '/videos/anime-doraemon-24.mp4',
        ],
    },
    'anime-shinchan': {
        bgQueries: ['Crayon Shin-chan', 'Shin Chan', 'Shinnosuke Nohara'],
        bonusVideoSrcs: [
            '/videos/anime-shinchan-01.mp4','/videos/anime-shinchan-03.mp4','/videos/anime-shinchan-04.mp4',
            '/videos/anime-shinchan-05.mp4','/videos/anime-shinchan-06.mp4','/videos/anime-shinchan-07.mp4',
            '/videos/anime-shinchan-08.mp4','/videos/anime-shinchan-09.mp4','/videos/anime-shinchan-10.mp4',
            '/videos/anime-shinchan-11.mp4',
        ],
    },
    'anime-jujutsu': {
        bgQueries: ['Satoru Gojo', 'Jujutsu Kaisen', 'Yuji Itadori'],
        bonusVideoSrcs: [
            '/videos/anime-jujutsu-01.mp4','/videos/anime-jujutsu-02.mp4','/videos/anime-jujutsu-03.mp4',
            '/videos/anime-jujutsu-04.mp4','/videos/anime-jujutsu-05.mp4','/videos/anime-jujutsu-06.mp4',
            '/videos/anime-jujutsu-07.mp4','/videos/anime-jujutsu-08.mp4','/videos/anime-jujutsu-09.mp4',
            '/videos/anime-jujutsu-10.mp4','/videos/anime-jujutsu-11.mp4','/videos/anime-jujutsu-12.mp4',
        ],
    },
    'anime-spyfamily': {
        bgQueries: ['Anya Forger', 'Spy x Family', 'Loid Forger'],
        bonusVideoSrcs: [
            '/videos/anime-spyfamily-01.mp4','/videos/anime-spyfamily-02.mp4','/videos/anime-spyfamily-03.mp4',
            '/videos/anime-spyfamily-04.mp4','/videos/anime-spyfamily-05.mp4','/videos/anime-spyfamily-06.mp4',
            '/videos/anime-spyfamily-07.mp4','/videos/anime-spyfamily-09.mp4','/videos/anime-spyfamily-10.mp4',
            '/videos/anime-spyfamily-12.mp4',
        ],
    },
    'anime-haikyuu': {
        bgQueries: ['Haikyu', 'Shoyo Hinata', 'Haikyuu anime'],
        bonusVideoSrcs: [
            '/videos/anime-haikyuu-01.mp4','/videos/anime-haikyuu-02.mp4','/videos/anime-haikyuu-03.mp4',
            '/videos/anime-haikyuu-04.mp4','/videos/anime-haikyuu-05.mp4','/videos/anime-haikyuu-06.mp4',
            '/videos/anime-haikyuu-07.mp4','/videos/anime-haikyuu-08.mp4','/videos/anime-haikyuu-09.mp4',
            '/videos/anime-haikyuu-10.mp4','/videos/anime-haikyuu-12.mp4','/videos/anime-haikyuu-13.mp4',
        ],
    },
    'anime-cars': {
        bgQueries: ['Lightning McQueen', 'Cars (film)', 'Mater (Cars)'],
        bonusVideoSrcs: [
            '/videos/anime-cars-05.mp4','/videos/anime-cars-08.mp4','/videos/anime-cars-11.mp4',
            '/videos/anime-cars-18.mp4','/videos/anime-cars-19.mp4','/videos/anime-cars-33.mp4',
            '/videos/anime-cars-35.mp4',
        ],
    },
    'anime-marvel-spiderman': {
        bgQueries: ['Spider-Man', 'Peter Parker', 'Miles Morales'],
        bonusVideoSrcs: [
            '/videos/anime-marvel-spiderman-01.mp4','/videos/anime-marvel-spiderman-02.mp4','/videos/anime-marvel-spiderman-04.mp4',
            '/videos/anime-marvel-spiderman-05.mp4','/videos/anime-marvel-spiderman-06.mp4','/videos/anime-marvel-spiderman-07.mp4',
            '/videos/anime-marvel-spiderman-08.mp4','/videos/anime-marvel-spiderman-09.mp4','/videos/anime-marvel-spiderman-12.mp4',
            '/videos/anime-marvel-spiderman-13.mp4','/videos/anime-marvel-spiderman-14.mp4','/videos/anime-marvel-spiderman-15.mp4',
        ],
    },
};

/** Get a random local bonus video source for a theme, or null. */
export const getBonusVideoSrc = (themeId: string): string | null => {
    const extras = THEME_EXTRAS[themeId];
    if (!extras || !extras.bonusVideoSrcs || extras.bonusVideoSrcs.length === 0) return null;
    const idx = Math.floor(Math.random() * extras.bonusVideoSrcs.length);
    return extras.bonusVideoSrcs[idx];
};
